"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNum = void 0;
const isNum = (val) => {
    return !isNaN(val);
};
exports.isNum = isNum;
